export enum UserType {
  driver = 'driver',
  customer = 'customer',
}

export enum UserStatus {
  active = 'active',
  suspended = 'suspended',
  blocked = 'blocked',
  pending = 'pending',
  deleted = 'deleted',
}

interface Social {
  facebook: { id: string };
  google: { id: string };
  apple: { id: string };
}

export interface User {
  _id: string;
  updatedAt?: Date;
  createdAt?: Date;
  fullName?: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  type: UserType;
  status: UserStatus;
  rating: number;
  profilePicture?: string;
  profilePictureUrl?: string;
  social?: Social;
}

export function getUserDisplayName(user: User): string {
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }
  return user.fullName || '';
}

export interface Driver extends User {
  type: UserType.driver;
  carModel: string;
  licensePlate: string;
  badgeNumber?: string;
  suspendedUntil?: Date;
  companyId?: string;
  companyName?: string;
}

export interface Customer extends User {
  type: UserType.customer;
  ridesCount: number;
}
